import React, {FC, useEffect, useState} from 'react';
import {ROUTES} from 'constants/routes';
import {
  selectInternationalProviderOnboardingStatus,
  // selectProvider,
  selectProviderVerifiedByWellniteTeam,
} from 'features/Provider/providerSelectors';
import {selectUserProfile} from 'features/User';
import {
  CurrentUser,
  InternationaProviderOnboardingStatusTypes,
  ProviderLicenseCategory,
  ProviderRegistrationSource,
} from 'interfaces';
import {useSelector} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {isProvider, isUserFromUnitedStates} from 'utils';

export const isOnboardingComplete = (user: CurrentUser, stage: number) => {
  if (
    user &&
    isProvider(user) &&
    user?.source !== undefined &&
    user?.source === ProviderRegistrationSource.provider &&
    user.deelContractId !== undefined &&
    user.onboarding?.onboardingStage !== undefined &&
    user.onboarding?.onboardingStage > stage
  ) {
    return true;
  } else {
    return false;
  }
};

export const withProviderOnboarding: (
  Component: FC,
) => () => JSX.Element = Component => {
  const WithProviderOnboardingWrapper = () => {
    const user = useSelector(selectUserProfile);
    // const provider = useSelector(selectProvider);
    const [showOnboarding, setShowOnboarding] = useState(false);
    const userFromUnitedStatesCheck = isUserFromUnitedStates(user);
    const internationalOnboardingStatus = useSelector(
      selectInternationalProviderOnboardingStatus,
    );
    const isVerified = useSelector(selectProviderVerifiedByWellniteTeam);

    useEffect(() => {
      if (
        user &&
        isProvider(user) &&
        user?.source !== undefined &&
        user?.source === ProviderRegistrationSource.provider
      ) {
        if (!userFromUnitedStatesCheck) {
          setShowOnboarding(
            internationalOnboardingStatus !==
              InternationaProviderOnboardingStatusTypes.completedOnboarding ||
              !isVerified,
          );
        } else if (
          user.providerLicenseCategory === ProviderLicenseCategory.licensed
        ) {
          setShowOnboarding(!isOnboardingComplete(user, 4));
        } else if (
          user.providerLicenseCategory === ProviderLicenseCategory.associate
        ) {
          setShowOnboarding(!isOnboardingComplete(user, 3));
        } else if (
          user.providerLicenseCategory === ProviderLicenseCategory.physician ||
          user.providerLicenseCategory ===
            ProviderLicenseCategory.nursePractitioner
        ) {
          setShowOnboarding(!isOnboardingComplete(user, 4));
        } else {
          setShowOnboarding(false);
        }
      } else {
        setShowOnboarding(false);
      }
    }, [user, internationalOnboardingStatus, isVerified]);

    if (showOnboarding) {
      const redirectPath = userFromUnitedStatesCheck
        ? ROUTES.PROVIDER.REGISTRATION_ONBOARDING
        : ROUTES.PROVIDER.INTERNATIONAL_REGISTRATION;

      return <Redirect to={redirectPath} />;
    }

    if (
      isProvider(user) && // check if user is provider
      !userFromUnitedStatesCheck && // check if user is not from united states
      !user?.paypalMerchantId && // check if user has paypal merchant id
      !(user?.stripeAccountId && user?.stripeConnectOnboardingComplete) && // check if user has stripe account id and stripe connect onboarding complete
      !user?.paystackSubaccountDetails?.subaccountId // check if user has paystack subaccount
    ) {
      return <Redirect to={ROUTES.PROVIDER.REVENUE.DIGITAL_PRACTICE} />;
    }

    return <Component />;
  };

  return WithProviderOnboardingWrapper;
};
